import { oneOf } from 'prop-types';
import { Icomoon } from './icons-data';
import cx from 'classnames';
import s from './styles.scss';

const Icon = ({ name, size, color, className }) => {
  return (
    <div className={cx(s.icon, s[`${size}`], s[`${color}`], className)}>
      <i className={`icon-${name}`} />
    </div>
  );
};

Icon.propTypes = {
  name: oneOf(Icomoon.icons.map((icon) => icon.properties.name)).isRequired,
  size: oneOf(['small', 'default', 'large']),
  color: oneOf(['inherit', 'blue', 'black', 'red']),
};

Icon.defaultProps = {
  size: 'default',
  color: 'inherit',
};

export default Icon;
